import { useState } from "react";

export const DisabledCardPopOver = ({ text, component,show }: any) => {
  const [open, setOpen] = useState<any>(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };
  return (
    <>
      <div
        onMouseEnter={() => handleMouseEnter()}
        onMouseLeave={() => handleMouseLeave()}
        className="w-60"
      >
      {open && show && <div className="DisabledCardPopOver space-y-2">
          <p className="font-medium">{text}</p>
        </div>}
        </div>
      <div
        onMouseEnter={() => handleMouseEnter()}
        onMouseLeave={() => handleMouseLeave()}
      >
        {component}
      </div>
    </>
  );
};
